import { Add } from "@mui/icons-material";
import { Box, Button, Grid2, Paper, Stack, Typography, CircularProgress } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import FormikTextField from "../../components/form/FormikTextField";
import { useNavigate, useParams } from "react-router";
import { deliverySlotsUrl } from "../../utils/urls";
import { useDispatch } from "react-redux";
import axiosInstance from "../../utils/axiosInstance";
import { hideLoader, showLoader } from "../../store/loaderSlice";
import { toast } from "react-hot-toast";
import PageHeader from "../../components/page-layout/PageHeader";
import { errorHandler } from "../../utils/errorHandler";
import moment from "moment";

const EditDeliverySlot = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationSchema = Yup.object({
    name: Yup.string().required("Delivery name is required"),
    start_time: Yup.string().required("Start time is required"),
    close_time: Yup.string().required("Close time is required"),
  });

  const [initialValues, setInitialValues] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(showLoader("Delivery Slots data fetching...."));
    setIsLoading(true);
    
    axiosInstance
      .get(`${deliverySlotsUrl}/${id}`)
      .then((res) => {
        const data = res.data;
        console.log({ data });
        
        const startTime = data.startTime ? data.startTime.substring(0, 5) : "07:00";
        const closeTime = data.closeTime ? data.closeTime.substring(0, 5) : "21:00";
        
        console.log({ startTime, closeTime });
        
        setInitialValues({
          name: data.name || "",
          start_time: startTime,
          close_time: closeTime,
        });
      })
      .catch((err) => {
        errorHandler(err);
      })
      .finally(() => {
        dispatch(hideLoader());
        setIsLoading(false);
      });
  }, [id, dispatch]);

  const onSubmit = (values) => {
    const submitData = {
      name: values.name,
      startTime: `${values.start_time}:00`,
      closeTime: `${values.close_time}:00`,
    };

    dispatch(showLoader("Updating Delivery Slot..."));
    axiosInstance
      .patch(`${deliverySlotsUrl}/${id}`, submitData)
      .then((data) => {
        toast.success(data.data.message);
        navigate(-1);
        dispatch(hideLoader());
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response?.data?.error || "An error occurred");
        dispatch(hideLoader());
      });
  };

  // Helper function to convert 24-hour to 12-hour AM/PM format
  const formatTo12Hour = (time24) => {
    return moment(time24, "HH:mm").format("hh:mm A");
  };

  if (isLoading || !initialValues) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, values }) => (
          <>
            <PageHeader
              title="Edit Delivery Slot"
              showBack={true}
              buttonTitle={"Update Delivery Slot"}
              buttonOnClick={handleSubmit}
            />

            {/* Visualize start and end time with AM/PM format */}
            <Box display="flex" justifyContent="center" py={2}>
              <Paper
                elevation={2}
                sx={{
                  px: 4,
                  py: 2,
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Typography variant="subtitle1" color="text.secondary">
                  Open Time:
                </Typography>
                <Typography variant="h4" color="primary">
                  {formatTo12Hour(values.start_time)}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  —
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  Close Time:
                </Typography>
                <Typography variant="h4" color="error">
                  {formatTo12Hour(values.close_time)}
                </Typography>
              </Paper>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 12 }}>
                  <FormikTextField name="name" label="Delivery Slot Name" />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <FormikTextField
                    name="start_time"
                    label="Open Time"
                    type="time"
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <FormikTextField
                    name="close_time"
                    label="Close Time"
                    type="time"
                  />
                </Grid2>
              </Grid2>
            </Box>
          </>
        )}
      </Formik>
    </Box>
  );
};

export default EditDeliverySlot;
